import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Button, Modal, Transition } from 'semantic-ui-react';
import { Creators as beneficiariosCreator } from '../../store/ducks/beneficiarios';
import { Creators as combosCreator } from '../../store/ducks/combos';
import { Creators as dadosClienteCreator } from '../../store/ducks/dados-cliente';
import { Creators as dadosComplementaresCreator } from '../../store/ducks/dados-complementares';
import { Creators as dadosCotacaoCreator } from '../../store/ducks/dados-cotacao';
import { Creators as enderecosCreator } from '../../store/ducks/enderecos';
import { Creators as leafletCreator } from '../../store/ducks/leaflet';
import { Creators as listaBensCreator } from '../../store/ducks/lista-bens';
import { Creators as stepCreator } from '../../store/ducks/step';
import { Creators as tiposimulacaoCreator } from '../../store/ducks/tipo-simulacao';
import { Creators as historicoAcessoCreators } from '../../store/ducks/historico-acesso';
import { animationDuration, fadeAnimation } from './../../consts/system-const';
import SessionService from './../../session/session-service';
import styles from './styles.module.scss';

class ModalNovaSimulacao extends Component {
    constructor(props) {
        super(props);
        if (this.props.newSimAction) {
            this.props.newSimAction(this.newSimAction);
        }
    }

    newSimAction = () => {
        const chaveSegMais = SessionService.getChaveSegMais();
        const chaveBroto = SessionService.getChaveBroto();

        const dispatch = this.props.dispatch;
        dispatch(beneficiariosCreator.reset());
        dispatch(combosCreator.reset());
        dispatch(dadosClienteCreator.reset());
        dispatch(dadosComplementaresCreator.reset());
        dispatch(dadosCotacaoCreator.reset());
        dispatch(enderecosCreator.reset());
        dispatch(leafletCreator.reset());
        dispatch(listaBensCreator.reset());
        dispatch(stepCreator.reset());
        dispatch(tiposimulacaoCreator.reset());
        dispatch(historicoAcessoCreators.setHistoricoAcesso(undefined, chaveSegMais, chaveBroto));
        SessionService.clearSession();
        dispatch(dadosCotacaoCreator.setPenhorRural());
        this.props.history.push('/');
        this.props.handlerCloseModal();
    };

    render() {
        const { header, open } = this.props;
        return (
            <Transition.Group duration={animationDuration} animation={fadeAnimation}>
                {open && (
                    <Modal open={open} closeIcon onClose={this.props.handlerCloseModal}>
                        <div className={styles.divModal}>
                            <p className={styles.headerModal}>Atenção!</p>
                            <p className={styles.textModal}>
                                {header ? header : 'Esta ação irá cancelar a simulação atual, deseja continuar?'}
                            </p>
                            <div className={[styles.padding0, styles.btnGroupContainer].join(' ')}>
                                <Button className={styles.btnVoltar} onClick={() => this.newSimAction()}>
                                    Sim
                                </Button>
                                <Button className={styles.btnAvancar} onClick={() => this.props.handlerCloseModal()}>
                                    Não
                                </Button>
                            </div>
                        </div>
                    </Modal>
                )}
            </Transition.Group>
        );
    }
}

export default withRouter(connect()(ModalNovaSimulacao));
